import React from "react";
import { AN_COLORS } from "../../../design-system/tokens";
import { outcomeMeta } from "./auditLogModel";

// Result pill: Success green / Failed amber / Denied red.
const TONES = {
  success: { bg: AN_COLORS.successBg, bd: AN_COLORS.successBd, fg: AN_COLORS.successFg },
  warn: { bg: AN_COLORS.warnBg, bd: AN_COLORS.warnBd, fg: AN_COLORS.warnFg },
  danger: { bg: AN_COLORS.dangerBg, bd: AN_COLORS.dangerBd, fg: AN_COLORS.dangerFg },
  neutral: { bg: AN_COLORS.bg, bd: AN_COLORS.line, fg: AN_COLORS.muted },
};

export function ResultPill({ outcome }) {
  const { label, tone } = outcomeMeta(outcome);
  const t = TONES[tone] || TONES.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "0.375rem",
        padding: "0.0625rem 0.5rem",
        borderRadius: "62.5rem",
        border: `1px solid ${t.bd}`,
        background: t.bg,
        color: t.fg,
        fontSize: "0.75rem",
        fontWeight: 600,
        lineHeight: "1.25rem",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ width: "0.375rem", height: "0.375rem", borderRadius: "50%", background: t.fg, flexShrink: 0 }} />
      {label}
    </span>
  );
}
